<!-- 连续型电子出版物查看 -->

<template>
  <div class="province-A">
    <div class="headBar linkRoutes">
      <span>出版连续型电子出版物单位审核</span>
      <i class="el-icon-arrow-right"></i>
      <span>{{ querys.pressName }}</span>
    </div>
    <div class="rejects" v-if="opMsg">
      <div class="rejLine">
        <div class="rejName">状态：</div>
        <div class="rejText">退回</div>
      </div>
      <div class="rejLine">
        <div class="rejName">原因：</div>
        <div class="rejText">{{ opMsg }}</div>
      </div>
    </div>
    <MainTabs ref="mainTab" v-if="wSat == 1" :bookName="bookName" :pressDat="resDat" role="show" />
    <div class="progressTab">
      <div class="headBar">
        <span>审核历史</span>
      </div>
      <el-table :data="tabDat" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="examineName" width="320" label="单位" align="center"></el-table-column>
        <el-table-column prop="name" width="120" label="状态" align="center">
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            {{ scope.row | tansStr("state") }}
          </template>
        </el-table-column>
        <el-table-column prop="examineMessage" label="审核意见" align="center"></el-table-column>
        <el-table-column prop="pubNumber" width="120" label="批准文号" align="center"></el-table-column>
        <el-table-column prop="checkdAt" width="180" label="操作时间" align="center">
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            {{ scope.row | tansStr("checkdAt") }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="querys.pressState == 1" class="subArea">
      <div
        class="headBar"
        style="height: auto; line-height: 20px; margin-bottom: 10px; padding-bottom: 10px; background-color: #fff">
        <span>
          <span style="color: red; font-weight: bold"
            >1.因出版单位在系统填写中存在问题，需退回出版单位修正的，按“退回”键。</span
          ><br />
          <span style="color: red; font-weight: bold"
            >2.审核意见提交（3选1）<br />
            <span style="color: red; font-weight: bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;①&nbsp;通过<br /></span>
            <span style="color: red; font-weight: bold"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;②&nbsp;暂缓登记（暂不具备年检通过条件，但仍继续办社的，选此项）<br
            /></span>
            <span style="color: red; font-weight: bold"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;③&nbsp;注销或拟注销（暂不具备办社基本条件且已经主办单位同意进行注销的，选此项）<br
            /></span>
          </span>
        </span>
      </div>
      <div class="radioBx" style="padding: 10px 30px">
        <!-- <el-radio-group v-model="params.status">
          <el-radio :label="'1'">通过</el-radio>
          <el-radio :label="'3'">退回</el-radio>
					<el-radio :label="'12'">暂缓</el-radio>
					<el-radio :label="'13'">注销或拟注销</el-radio>
					<el-radio :label="'14'">建议撤销</el-radio>
        </el-radio-group> -->
        <!-- <el-input v-if="params.status == '3'" v-model="params.message" type="textarea" :rows="5"
					placeholder="请填写退回意见"></el-input>
				<el-input v-if="params.status == '12'" v-model="params.zanhuanMessage" type="textarea" :rows="5"
					placeholder="请填写暂缓意见"></el-input>
				<el-input v-if="params.status == '13'" v-model="params.zhuxiaoMessage" type="textarea" :rows="5"
					placeholder="请填写注销或拟注销意见"></el-input>
				<el-input v-if="params.status == '14'" v-model="params.chexiaoMessage" type="textarea" :rows="5"
					placeholder="请填写建议撤销意见"></el-input> -->
        <el-radio-group v-model="params.status">
          <el-radio :label="'1'">通过</el-radio>
          <el-radio :label="'21'">暂缓登记</el-radio>
          <el-radio :label="'13'">注销或拟注销</el-radio>
        </el-radio-group>
        <el-input
          v-if="
            params.status == '1' ||
            params.status == '3' ||
            params.status == '21' ||
            params.status == '12' ||
            params.status == '13'
          "
          v-model="params.message"
          type="textarea"
          :rows="5"
          placeholder="请填写意见"></el-input>
      </div>
    </div>
    <div class="subLine">
      <el-button @click="goBack">返回</el-button>
      <el-button v-if="querys.pressState == 1" @click="goBackExamsave" type="warning">退回</el-button>
      <!-- <el-button v-if="querys.pressState == 1" @click="goExamsave" type="danger">提交</el-button> -->
      <el-button v-if="querys.pressState == 1" @click="goExamsave" type="danger">提交审核意见</el-button>
    </div>
  </div>
</template>

<script>
import MainTabs from "@/views/components/SPEC/ssCommonTabs";
import { getSuccessCheckTabs } from "@/api/pressRole/pressSuccessive";
import { goProvinceExam, successiveHistoryNew, writeReadTimeLxdz } from "@/api/provinceRole/provinceRole";
import { getSelYearRecord } from "@/api/pressRole/pressRole";
export default {
  components: {
    MainTabs,
  },
  data() {
    return {
      wSat: 0,
      querys: {
        pressState: 1,
        pressName: "",
        pgsType: "",
        year1: "",
      },
      bookName: "",
      resDat: [{}],
      selYearRecord: [{}],
      tabDat: [],

      opMsg: "",

      params: {
        publishMaterialIds: [],
        status: "1",
        message: "",
        zanhuanMessage: "", // zym.暂缓意见
        chexiaoMessage: "", // zym.撤销意见
        zhuxiaoMessage: "", // zym.注销意见
      },
    };
  },
  filters: {
    tansStr: function (dat, code) {
      if (code == "state") {
        if (dat.flowName == "省局") {
          let map = {
            1: "通过",
            3: "退回",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销",
            21: "暂缓登记",
          };

          return map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          let map = {
            1: "通过",
            2: "暂缓",
            3: "退回",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布",
          };

          return map[dat.status];
        } else if (dat.flowName == "登记") {
          let map = {
            0: "待登记",
            1: "待登记",
            2: "已登记",
          };

          return map[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (!dat["checkdAt"] || dat["checkdAt"] == "Invalid date") {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    },
  },
  methods: {
    valChangeSearch: function (year) {
      this.getHistoryData(year);
    },
    goBack: function () {
      this.$router.go(-1);
      // let urlArrs = ['successive_exam','ss_regist'];
      // this.$router.push({
      //     path:urlArrs[this.querys.pgsType - 1]
      // })
    },
    goBackExamsave: function () {
      const msg = "请填写意见！";
      if ((this.params.message || "").length == 0) {
        this.$message.error(msg);
      } else {
        let msg = "确定已查看完毕，退回出版单位吗？";
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.params.publishMaterialIds = [];
            this.params.publishMaterialIds.push(this.$route.query.examId);

            // 创建新的参数
            let paramsNew = { ...this.params, status: "3" };
            let vm = this;
            const loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });

            goProvinceExam(paramsNew).then((response) => {
              loading.close();

              let tipCode = response.payload.tipCode;
              let tipMessage = response.payload.tipMessage;
              let resMsg = response.payload.resMsg;
              let appendMsg = resMsg ? resMsg.join(",") : "";
              // console.log('response=',JSON.stringify(response));
              if (tipCode == "fail") {
                this.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "error",
                });
              } else {
                this.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "success",
                });

                // zym.原来的方法
                this.goBack();
              }
            });
          })
          .catch(() => {});
      }
    },
    goExamsave: function () {
      this.params.message = this.params.message || "";
      this.params.message = this.params.message.replace(/\s+/g, "");
      if (this.params.status == 12) {
        this.params.zanhuanMessage = this.params.message.replace(/\s+/g, "");
      }
      if (this.params.status == 13) {
        this.params.zhuxiaoMessage = this.params.message.replace(/\s+/g, "");
      }
      if (this.params.status == 14) {
        this.params.chexiaoMessage = this.params.message.replace(/\s+/g, "");
      }

      // this.params.zanhuanMessage = this.params.zanhuanMessage.replace(/\s+/g,"");
      // this.params.chexiaoMessage = this.params.chexiaoMessage.replace(/\s+/g,"");
      // this.params.zhuxiaoMessage = this.params.zhuxiaoMessage.replace(/\s+/g,"");
      const msg = "请填写意见！";
      if (this.params.status == 3 && this.params.message.length == 0) {
        this.$message.error(msg);
        // this.$message.error('请填写退回意见！');
      } else if (this.params.status == 21 && this.params.message.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写暂缓登记意见！");
      } else if (this.params.status == 12 && this.params.zanhuanMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error('请填写暂缓意见！');
      } else if (this.params.status == 13 && this.params.zhuxiaoMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error('请填写注销或拟注销意见！');
      } else if (this.params.status == 14 && this.params.chexiaoMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error('请填写建议撤销意见！');
      } else {
        // let msg = "确定已查看完毕，并对该连续型电子出版物批以通过处理吗？"; // zym.通过
        // if (this.params.status == 3) {
        //   msg = "确定已查看完毕，并对该连续型电子出版物批以退回处理吗？";
        // } else if (this.params.status == 12) {
        //   msg = "确定已查看完毕，并对该连续型电子出版物批以暂缓吗？";
        // } else if (this.params.status == 13) {
        //   msg = "确定已查看完毕，并对该连续型电子出版物批以注销或拟注销吗？";
        // } else if (this.params.status == 14) {
        //   msg = "确定已查看完毕，并对该连续型电子出版物批以建议撤销吗？";
        // } else if (this.params.status == 1) {
        //   msg = "确定已查看完毕，并对该连续型电子出版物批以通过处理吗？";
        // } else {
        //   this.$message.error("发现不可操作的审批结果，无法进行操作！");
        //   return;
        // }
        let msg = "确定已查看完毕，提交审核意见吗？";
        if (this.params.status == 3) {
          msg = "确定已查看完毕，退回出版单位吗？";
        }
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.params.publishMaterialIds = [];
            this.params.publishMaterialIds.push(this.$route.query.examId);
            let vm = this;
            const loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            goProvinceExam(this.params).then((response) => {
              // this.$message.info({
              // 	message: '若音像、电子出版单位全部审核完成，请前往上报板块向进行上报',
              // 	duration: 5000
              // });
              loading.close();

              let tipCode = response.payload.tipCode;
              let tipMessage = response.payload.tipMessage;
              let resMsg = response.payload.resMsg;
              let appendMsg = resMsg ? resMsg.join(",") : "";
              console.log("response=", JSON.stringify(response));
              if (tipCode == "fail") {
                this.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "error",
                });
              } else {
                this.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "success",
                });

                // zym.原来的方法
                this.goBack();
              }
            });
          })
          .catch(() => {});
      }
    },

    gPlist: function () {
      getSuccessCheckTabs({
        publishMaterialId: this.$route.query.listId,
        organizationId: this.$route.query.pressId,
      }).then((response) => {
        let vm = this;
        vm.wSat = 1;
        this.bookName = this.$route.query.bookName;
        if (this.querys.pressState == 1) {
          this.opMsg = response.msg;
        }
        this.resDat.splice(0, 1, response.ppublicationOrganizationMaterialList);
      });
    },
    getHistoryData(year) {
      let vm = this;
      // successiveHistory({ examineId: this.$route.query.examId, year1: year }).then(response => {
      //   for (let item of response.fFlowTaskList) {
      //     if (item.examineName) {
      //       vm.tabDat.push(item);
      //     }
      //   }
      // })
      successiveHistoryNew({ examineId: this.$route.query.examId }).then((response) => {
        this.tabDat = response.fFlowTaskList;
        //  successiveHistory({publishId:this.querys.mtId}).then(response => {
        // console.debug("successiveHistory: ", response);
        // for (let i = 0; i < response.fFlowTaskList.length; i++) {
        // 	if (response.fFlowTaskList[i].examineName) {
        // 		this.tabDat.push(response.fFlowTaskList[i]);
        // 	}
        // }
        // 查找最后的省局审核意见
        let tabDatProvince = (this.tabDat || []).filter((item) => {
          return item.flowName == "省局";
        });
        if (tabDatProvince && tabDatProvince.length > 0) {
          let last = tabDatProvince[tabDatProvince.length - 1];
          this.params.status = last.status == "0" ? "1" : last.status + "";
          this.params.message = last.examineMessage;
        } else {
          this.params.status = "1";
          this.params.message = "";
        }
      });
    },

    writeReadTimeLxdz: function () {
      writeReadTimeLxdz({
        publishMaterialId: this.$route.query.listId,
      }).then((response) => {
        console.debug("writeReadTimeLxdz: ", response);
      });
    },
  },

  created: function () {
    this.querys.pressState = this.$route.query.pressState;
    this.querys.pressName = this.$route.query.pressName;
    this.querys.year1 = this.$route.query.year1;

    this.gPlist();

    // 更新审阅时间
    if (this.$route.query.updateViewDate && this.$route.query.pressState != 2) {
      this.writeReadTimeLxdz();
    }

    // getSelYearRecord({
    //   publishId: this.$route.query.pressId,
    //   type: 3,
    //   year1: this.querys.year1
    // }).then(response => {
    //   console.log("======", response);
    //   var arr = [{}];
    //   if (response.generalPublisher.length > 0) {
    //     for (var i in response.generalPublisher) {
    //       var po = response.generalPublisher[i];
    //       arr.push({ label: po.firstYear + '~' + po.secondYear, value: po.firstYear });
    //     }
    //   }
    //   this.selYearRecord = arr;
    // })

    // if(this.querys.pressState == 2){
    this.getHistoryData(this.querys.year1);
    // }
  },
};
</script>

<style lang="scss">
.province-A {
  padding: 9px;

  .linkRoutes {
    margin-bottom: 9px;

    i {
      vertical-align: middle;
    }
  }

  .rejects {
    border: 1px solid red;
    color: red;
    padding: 15px 0px;
    border-radius: 3px;
    margin-bottom: 9px;

    .rejLine {
      position: relative;
      line-height: 20px;

      .rejName {
        width: 70px;
        font-size: 14px;
        text-align: right;
        float: left;
      }

      .rejText {
        margin-left: 65px;
        font-size: 14px;
      }
    }
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;

    span {
      font-size: 14px;
    }
  }

  .radioBx {
    padding: 30px 90px;
  }

  .el-textarea {
    margin-top: 20px;

    textarea {
      resize: none;
      border-radius: 0px;
    }
  }

  .subLine {
    text-align: center;
    margin: 30px 0px;

    .el-button {
      width: 180px;
      margin-top: 12px;
    }
  }

  .subArea {
    margin-top: 9px;
  }

  .progressTab .headBar {
    margin-top: 9px;
    margin-bottom: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// successiveTabs.vue?f326a2d8